import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";

import DataTable from "../../../lib/components/DataTable";
import pathnames from "../../../constants/pathnames";
import EmptyState from "../../../lib/components/EmptyState";
import { moneyFormat } from "../../../utils/moneyFormat";

const PaymentsDataTable = ({ data = [], isLoading, page, pageSize, totalPages, onPageChange, onPageSizeChange }) => {
  if (isLoading) return null;

  const columns = [
    {
      key: "client",
      header: "Client",
      render: (_, row) => (
        <Link to={`${pathnames.ORGANIZATIONS}/${row?.organizationId}`} className="fw-medium">
          {row?.organizationMeta?.name || "N/A"}
        </Link>
      ),
    },
    {
      key: "paymentId",
      header: "Payment Id",
    },
    {
      key: "paidAt",
      header: "Payment Date",
      type: "date",
      render: (value) => (value ? moment(value).format("Do MMM, YYYY") : "N/A"),
    },
    {
      key: "amountPaid",
      header: "Amount Paid",
      render: (value) => moneyFormat(value),
    },
    {
      key: "plan",
      header: "Plan",
      render: (_, row) => row?.subscriptionMeta?.planName || "N/A",
    },
    {
      key: "period",
      header: "Period",
      render: (_, row) => row?.subscriptionMeta?.billingInterval || "N/A",
    },
  ];

  return (
    <>
      <DataTable
        data={data}
        columns={columns}
        isLoading={isLoading}
        page={page}
        pageSize={pageSize}
        totalPages={totalPages}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />

      <EmptyState isEmpty={!isLoading && !data.length} />
    </>
  );
};

export default PaymentsDataTable;
